import { action, computed, decorate, observable } from "mobx";

class VideoPlayerStore {
  isOpen = false;
  videoSrc = "";

  hidePlayer() {
    this.isOpen = false;
    this.videoSrc = "";
  }

  showVideoSrc(link) {
    this.videoSrc = link;
    this.isOpen = true;
  }

  get isVideoDownloadable() {
    return !this.videoSrc.includes("fastball-clips.mlb.com");
  }
}

decorate(VideoPlayerStore, {
  isOpen: observable,
  videoSrc: observable,
  isVideoDownloadable: computed,
  showVideoSrc: action
});

export default VideoPlayerStore;



// WEBPACK FOOTER //
// ./src/stores/VideoPlayerStore.js